import { POSITIONTARIFFASTART} from './PositionTariffaStartTypes'

const initialState = {
    positionTariffaStart: [{
       description : "",
        lat: "",
        lng: ""
    }]
}

const PositionTariffaStartReducer = (state = initialState, action) => {
    
    switch (action.type) {
        case POSITIONTARIFFASTART:
            
            return {
                positionTariffaStart: action.load
            }
    
        default:
          return state
    }

}


export default PositionTariffaStartReducer;